
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, bool_type, lambda_type, unit_type, union_type, list_type, class_type, anonRecord_type, option_type, float64_type, string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { FormState__getValidation, FormState__startLoading, ConsumableId, UnassignConsumableV2Dto, FormState__setValidationResponse_5219762A, FormState_get_empty, FormState_$reflection, ClientApiResponse$1_$reflection } from "../../Shared/Shared.js";
import { ConsumableDetailDto_$reflection, StockPerStorageDto_$reflection } from "../../Shared/Consumable.js";
import { HookFlow_hasMandatoryUncompletedHooks, HookFlowSections, HookFlowProcedureModal, HookFlow_update, HookFlow_completedProcedureIds, HookFlow_initReturn, HookFlowState_$reflection, HookFlowMsg_$reflection } from "../../Widgets/Procedure/Hooks.js";
import { ImageUpload, DnDFormImage, DnDFormImage_$reflection } from "../../Widgets/Image/ImageUploadDnD.js";
import { FileUploadResponse_$reflection } from "../../Shared/File.js";
import { ProcedureEntityReferenceDto } from "../../Shared/Procedure.js";
import { length, singleton, append, max, filter, tryPick, sumBy, choose, ofArray, empty, head, tail, isEmpty, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { Cmd_none, Cmd_ofEffect, Cmd_batch, Cmd_map } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { Cmd_unassignCmd } from "../../Requests/Consumable.js";
import { Cmd_uploadImage } from "../../Requests/Files.js";
import { createObj, comparePrimitives } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { whenOpen } from "../../Widgets/Helper.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Dialog } from "../../Components/Dialog.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { empty as empty_1, singleton as singleton_1, append as append_1, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { Select } from "../../Components/Select.js";
import { unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { NumberInput } from "../../Components/Input.js";
import { TextArea } from "../../Components/TextArea.js";
import { TextValue } from "../../Components/Text.js";
import { ErrorAlert } from "../../Components/Alert.js";
import { TextButton } from "../../Components/Button.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UnassignResponse", "OnUnassign", "SetComment", "SetQuantity", "SetSelectedStorage", "FetchError", "HookMsg", "SetSelectedSenderFiles", "SenderImageUploaded"];
    }
}

function Msg_$reflection() {
    return union_type("Consumables.SelfServiceReturnConsumableDialog.Msg", [], Msg, () => [[["Item", ClientApiResponse$1_$reflection(string_type)]], [], [["Item", string_type]], [["Item", option_type(float64_type)]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", StockPerStorageDto_$reflection()]))]], [["Item", class_type("System.Exception")]], [["Item", HookFlowMsg_$reflection()]], [["Item", list_type(DnDFormImage_$reflection())]], [["Item", FileUploadResponse_$reflection()]]]);
}

class State extends Record {
    constructor(Consumable, UserId, Comment$, Quantity, SelectedStorage, SuccessCallback, OnClose, FormState, IsQuantityInvalid, IsStorageInvalid, SenderImageFiles, ImageUploading, Hooks) {
        super();
        this.Consumable = Consumable;
        this.UserId = UserId;
        this.Comment = Comment$;
        this.Quantity = Quantity;
        this.SelectedStorage = SelectedStorage;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.FormState = FormState;
        this.IsQuantityInvalid = IsQuantityInvalid;
        this.IsStorageInvalid = IsStorageInvalid;
        this.SenderImageFiles = SenderImageFiles;
        this.ImageUploading = ImageUploading;
        this.Hooks = Hooks;
    }
}

function State_$reflection() {
    return record_type("Consumables.SelfServiceReturnConsumableDialog.State", [], State, () => [["Consumable", ConsumableDetailDto_$reflection()], ["UserId", string_type], ["Comment", string_type], ["Quantity", option_type(float64_type)], ["SelectedStorage", option_type(anonRecord_type(["label", string_type], ["value", StockPerStorageDto_$reflection()]))], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["FormState", FormState_$reflection()], ["IsQuantityInvalid", bool_type], ["IsStorageInvalid", bool_type], ["SenderImageFiles", list_type(DnDFormImage_$reflection())], ["ImageUploading", bool_type], ["Hooks", HookFlowState_$reflection()]]);
}

const maxSenderImages = 5;

function init(consumable, userId, selfServiceStorages, successCallback, onClose) {
    const patternInput = HookFlow_initReturn(new ProcedureEntityReferenceDto(2, [consumable.Id]), map((category) => parse(category.CategoryId), consumable.Categories));
    return [new State(consumable, userId, "", undefined, !isEmpty(selfServiceStorages) ? (isEmpty(tail(selfServiceStorages)) ? {
        label: head(selfServiceStorages).StorageName,
        value: head(selfServiceStorages),
    } : undefined) : undefined, successCallback, onClose, FormState_get_empty(), false, false, empty(), false, patternInput[0]), Cmd_map((Item) => (new Msg(6, [Item])), patternInput[1])];
}

function update(msg, state) {
    let file_1;
    switch (msg.tag) {
        case 0: {
            const response = msg.fields[0];
            if (response.tag === 1) {
                return [new State(state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.SuccessCallback, state.OnClose, FormState__setValidationResponse_5219762A(state.FormState, response.fields[0]), state.IsQuantityInvalid, state.IsStorageInvalid, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.SuccessCallback, state.OnClose, FormState_get_empty(), state.IsQuantityInvalid, state.IsStorageInvalid, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
        case 1: {
            const matchValue = state.SelectedStorage;
            const matchValue_1 = state.Quantity;
            if (matchValue != null) {
                if (matchValue_1 != null) {
                    if (matchValue_1 === 0) {
                        const quantity_1 = matchValue_1;
                        return [new State(state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.SuccessCallback, state.OnClose, state.FormState, true, state.IsStorageInvalid, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
                    }
                    else {
                        const quantity_2 = matchValue_1;
                        const storage = matchValue;
                        const dto = new UnassignConsumableV2Dto(state.UserId, storage.value.StorageId, state.Comment, quantity_2, "", choose((f) => {
                            if (f.tag === 1) {
                                return f.fields[0].ImageUrl;
                            }
                            else {
                                return undefined;
                            }
                        }, state.SenderImageFiles), HookFlow_completedProcedureIds(state.Hooks), undefined);
                        const consumableId = new ConsumableId(parse(state.Consumable.Id));
                        return [new State(state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.SuccessCallback, state.OnClose, FormState__startLoading(state.FormState), false, false, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_unassignCmd(consumableId, dto, (Item_2) => (new Msg(0, [Item_2])), (Item_3) => (new Msg(5, [Item_3])))];
                    }
                }
                else {
                    return [new State(state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.SuccessCallback, state.OnClose, state.FormState, true, state.IsStorageInvalid, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
                }
            }
            else {
                return [new State(state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, true, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
            }
        }
        case 2:
            return [new State(state.Consumable, state.UserId, msg.fields[0], state.Quantity, state.SelectedStorage, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, state.IsStorageInvalid, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
        case 3:
            return [new State(state.Consumable, state.UserId, state.Comment, msg.fields[0], state.SelectedStorage, state.SuccessCallback, state.OnClose, state.FormState, false, state.IsStorageInvalid, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
        case 4:
            return [new State(state.Consumable, state.UserId, state.Comment, state.Quantity, msg.fields[0], state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, false, state.SenderImageFiles, state.ImageUploading, state.Hooks), Cmd_none()];
        case 5:
            return [new State(state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.SuccessCallback, state.OnClose, FormState_get_empty(), state.IsQuantityInvalid, state.IsStorageInvalid, state.SenderImageFiles, false, state.Hooks), Cmd_none()];
        case 7: {
            const newFiles = msg.fields[0];
            const alreadyUploadedCount = sumBy((f_1) => {
                if (f_1.tag === 1) {
                    return 1;
                }
                else {
                    return 0;
                }
            }, state.SenderImageFiles, {
                GetZero: () => 0,
                Add: (x, y) => ((x + y) | 0),
            }) | 0;
            const pickedFile = tryPick((f_2) => {
                if (f_2.tag === 0) {
                    return f_2.fields[0].File;
                }
                else {
                    return undefined;
                }
            }, newFiles);
            let matchResult, file_2;
            if (pickedFile != null) {
                if ((file_1 = pickedFile, alreadyUploadedCount < maxSenderImages)) {
                    matchResult = 0;
                    file_2 = pickedFile;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const formData = new FormData();
                    formData.append(file_2.name, file_2);
                    return [new State(state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, state.IsStorageInvalid, newFiles, true, state.Hooks), Cmd_uploadImage((Item_4) => (new Msg(8, [Item_4])), (Item_5) => (new Msg(5, [Item_5])), formData)];
                }
                default:
                    return [new State(state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, state.IsStorageInvalid, newFiles, state.ImageUploading, state.Hooks), Cmd_none()];
            }
        }
        case 8: {
            const response_1 = msg.fields[0];
            switch (response_1.tag) {
                case 0:
                    return [new State(state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, state.IsStorageInvalid, filter((f_5) => {
                        if (f_5.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false, state.Hooks), Cmd_errorToast("general.file_too_large")];
                case 2:
                    return [new State(state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, state.IsStorageInvalid, filter((f_6) => {
                        if (f_6.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false, state.Hooks), Cmd_errorToast("general.a_error_occured")];
                default: {
                    const nextPosition = (1 + max(append(singleton(0), choose((f_3) => {
                        if (f_3.tag === 1) {
                            return f_3.fields[0].Position;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles)), {
                        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                    })) | 0;
                    return [new State(state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, state.IsStorageInvalid, append(choose((f_4) => {
                        if (f_4.tag === 1) {
                            return f_4;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles), singleton(new DnDFormImage(1, [{
                        ImageUrl: response_1.fields[0].ImageUrl,
                        Position: nextPosition,
                    }]))), false, state.Hooks), Cmd_none()];
                }
            }
        }
        default: {
            const patternInput = HookFlow_update(msg.fields[0], state.Hooks);
            return [new State(state.Consumable, state.UserId, state.Comment, state.Quantity, state.SelectedStorage, state.SuccessCallback, state.OnClose, state.FormState, state.IsQuantityInvalid, state.IsStorageInvalid, state.SenderImageFiles, state.ImageUploading, patternInput[0]), Cmd_map((Item) => (new Msg(6, [Item])), patternInput[1])];
        }
    }
}

export function SelfServiceReturnConsumableDialog(props) {
    let elems_2, Title, elems_1, Label_4;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => {
        const tupledArg = init(props.Consumable, props.UserId, props.SelfServiceStorages, props.SuccessCallback, props.OnClose);
        return whenOpen(props.IsOpen, tupledArg[0], tupledArg[1]);
    }, update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_2 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const componentState = state_2.FormState.IsLoading ? "disabled" : "enabled";
    const storageOptions = map((sps) => ({
        label: sps.StorageName,
        value: sps,
    }), props.SelfServiceStorages);
    return reactElement("div", createObj(singleton((elems_2 = [createElement(HookFlowProcedureModal, {
        Dispatch: (arg) => {
            dispatch(new Msg(6, [arg]));
        },
        State: state_2.Hooks,
    }), createElement(Dialog, (Title = t("general.self_service_return_title"), {
        Body: singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems_1 = toList(delay(() => append_1(singleton_1(reactElement("p", {
            children: t("general.self_service_return_description"),
        })), delay(() => append_1((length(storageOptions) > 1) ? singleton_1(createElement(Select, {
            ComponentState: componentState,
            IsClearable: false,
            Label: t("tool.switch_storage_target"),
            NoOptionsMessage: "",
            OnChange: (value_3) => {
                dispatch(new Msg(4, [value_3]));
            },
            Options: storageOptions,
            PlaceholderKey: "",
            TestId: "self-service-return-consumable-dialog-storage-test-id",
            ValidationMessage: unwrap(state_2.IsStorageInvalid ? "tool.switch_storage_missing_storage_validation" : undefined),
            Value: unwrap(state_2.SelectedStorage),
        })) : empty_1(), delay(() => append_1(singleton_1(createElement(NumberInput, {
            ComponentState: componentState,
            Label: t("general.quantity_3"),
            OnChange: (value_4) => {
                dispatch(new Msg(3, [value_4]));
            },
            TestId: "self-service-return-consumable-dialog-quantity-test-id",
            ValidationMessage: unwrap(state_2.IsQuantityInvalid ? t("tool.dialog_assign_quantity_empty_validation") : undefined),
            Value: unwrap(state_2.Quantity),
        })), delay(() => append_1(singleton_1(createElement(TextArea, {
            ComponentState: componentState,
            Label: t("general.comment"),
            OnChange: (value_5) => {
                dispatch(new Msg(2, [value_5]));
            },
            TestId: "self-service-return-consumable-dialog-comment-test-id",
            Value: state_2.Comment,
        })), delay(() => {
            let elems;
            return append_1(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems = [createElement(TextValue, {
                FontWeight: "bold",
                TestId: "",
                Text: t("assignment_notification.sender_images"),
            }), createElement(ImageUpload, {
                ComponentState: state_2.ImageUploading ? "disabled" : componentState,
                SelectedFiles: state_2.SenderImageFiles,
                SetSelectedFile: (files) => {
                    dispatch(new Msg(7, [files]));
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => append_1(singleton_1(createElement(HookFlowSections, {
                Dispatch: (arg_1) => {
                    dispatch(new Msg(6, [arg_1]));
                },
                FormState: state_2.FormState,
                ReceiverTitleKey: "procedure.hooks.receiver_procedures_return",
                SenderTitleKey: "procedure.hooks.sender_procedures_return",
                State: state_2.Hooks,
                TestIdPrefix: "self-service-return-consumable",
            })), delay(() => {
                const matchValue = FormState__getValidation(state_2.FormState, t, "global");
                if (matchValue == null) {
                    return empty_1();
                }
                else {
                    return singleton_1(createElement(ErrorAlert, {
                        Label: matchValue,
                    }));
                }
            }))));
        })))))))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: componentState,
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-self-service-return-consumable-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, (Label_4 = t("general.save"), {
            ComponentState: (state_2.ImageUploading ? true : HookFlow_hasMandatoryUncompletedHooks(state_2.Hooks)) ? "disabled" : componentState,
            Label: Label_4,
            OnClick: () => {
                dispatch(new Msg(1, []));
            },
            TestId: "save-self-service-return-consumable-dialog-test-id",
            Variant: "blueButton",
        }))]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_2))]))));
}

